/**
 * ---------------------------------------------------------------------------------
 * Proto (v1.2.0): card.js
 * Licensed under GNU
 * ---------------------------------------------------------------------------------
 */
import $ from 'jquery';
import { Util } from 'Shared/util/bootstrap/v4';

/**
 * -----------------------------------------------------------------------------
 * Constants
 * -----------------------------------------------------------------------------
 */

const NAME                      = 'promvc-card';
const VERSION                   = '2.0.0';
const DATA_KEY                  = 'promvc.card';
const EVENT_KEY                 = `.${DATA_KEY}`;
const DATA_API_KEY              = '.data-api';
const TRANSITION_DURATION       = 0;

const ClassName = {
	ACTIVE                      : 'plan-card--highlight',
	BUTTON_ACTIVE               : 'primary-button',
	BUTTON_INACTIVE             : 'secondary-button',
	DESKTOP_ADDON_ACTIVE        : 'plan-card__expanded-section--open',
	DESKTOP_BUTTON_ADDON_ACTIVE : 'plan-card__expand-button--open',
	MOBILE_ADDON_ACTIVE         : 'plan-card__mobile-wrapper--open',
	MOBILE_BUTTON_ADDON_ACTIVE  : 'plan-card__mobile-expand-button--open'
};

const Event = {
	SHOW                        : `show${EVENT_KEY}`,
	SHOWN                       : `shown${EVENT_KEY}`,
	HIDE                        : `hide${EVENT_KEY}`,
	CLICK                       : `click${EVENT_KEY}`,
	MOUSE_ENTER_LEAVE_DATA_API  : `mouseenter${EVENT_KEY}${DATA_API_KEY} ` + `mouseleave${EVENT_KEY}${DATA_API_KEY}`
};

const Selector = {
	MOUNT                       : 'appMountPoint',
	CARD                        : 'plan-card'
};

/**
 * -----------------------------------------------------------------------------
 * Class definition
 * -----------------------------------------------------------------------------
 */

class PromvcCard
{
	constructor( element = null )
	{
		this._isTransitioning = false;
		this._parent          = element;
		this._button          = element.children[ 1 ].children[ 0 ].children[ 3 ].firstChild;
		this._mobileWrapper   = element.children[ 1 ].children[ 1 ];
		this._sectionWrapper  = this._mobileWrapper.children[ 1 ];
		this._desktopExpander = element.children[ 1 ].children[ 2 ].firstChild;
		this._mobileExpander  = element.children[ 1 ].children[ 2 ].lastChild;

		this.registerEvents();
	}

	// getters

	static get VERSION()
	{
		return VERSION;
	}

	// public

	registerEvents()
	{
		var button = this._button;
		var addOnDesktop = this._sectionWrapper;
		var addOnMobile  = this._mobileWrapper;

		// Button active
		$( this._parent ).on( Event.SHOW, function () {
			$( button )
				.removeClass( ClassName.BUTTON_INACTIVE )
				.addClass( ClassName.BUTTON_ACTIVE );
		});

		// Button inactive
		$( this._parent ).on( Event.HIDE, function () {
			$( button )
				.removeClass( ClassName.BUTTON_ACTIVE )
				.addClass( ClassName.BUTTON_INACTIVE );
		});

		// Toggle desktop
		$( this._desktopExpander ).on( Event.CLICK, function ( e ) {
			e.preventDefault();
			if ( $( this ).hasClass( ClassName.DESKTOP_BUTTON_ADDON_ACTIVE ) ) {
				$( this )
					.removeClass( ClassName.DESKTOP_BUTTON_ADDON_ACTIVE )
					.html( 'See Add-ons &nbsp;<span class="plan-card__icon-plus"></span>' );
				$( addOnDesktop )
					.removeClass( ClassName.DESKTOP_ADDON_ACTIVE );
			} else {
				$( this )
					.addClass( ClassName.DESKTOP_BUTTON_ADDON_ACTIVE )
					.html( 'Close Add-ons &nbsp;<span class="plan-card__icon-plus"></span>' );
				$( addOnDesktop )
					.addClass( ClassName.DESKTOP_ADDON_ACTIVE );
			}
			e.stopPropagation();
		});

		// Toggle mobile
		$( this._mobileExpander ).on( Event.CLICK, function ( e ) {
			e.preventDefault();
			if ( $( this ).hasClass( ClassName.MOBILE_BUTTON_ADDON_ACTIVE ) ) {
				$( this )
					.removeClass( ClassName.MOBILE_BUTTON_ADDON_ACTIVE )
					.html( 'See details &nbsp;<span class="plan-card__icon-plus-mobile"></span>' );
				$( addOnMobile )
					.removeClass( ClassName.MOBILE_ADDON_ACTIVE );
			} else {
				$( this )
					.addClass( ClassName.MOBILE_BUTTON_ADDON_ACTIVE )
					.html( 'Close details &nbsp;<span class="plan-card__icon-plus-mobile"></span>' );
				$( addOnMobile )
					.addClass( ClassName.MOBILE_ADDON_ACTIVE );
			}
			e.stopPropagation();
		});
	}

	setTransitioning( isTransitioning )
	{
		this._isTransitioning = isTransitioning;
	}

	focus()
	{
		if ( this._isTransitioning || $( this._parent ).hasClass( ClassName.ACTIVE ) ) {
			return;
		}

		const startEvent = $.Event( Event.SHOW );
		$( this._parent ).trigger( startEvent );
		if ( startEvent.isDefaultPrevented() ) {
			return;
		}

		this.setTransitioning( true );

		const complete = () => {
			$( this._parent ).addClass( ClassName.ACTIVE );
			this.setTransitioning( false );
			$( this._parent ).trigger( Event.SHOWN );
		};

		if ( ! Util.supportsTransitionEnd() ) {
			console.log( 'no transition' );
			complete();
			return;
		}

		$( this._parent )
			.one( Util.TRANSITION_END, complete )
			.emulateTransitionEnd( TRANSITION_DURATION );
	}

	unfocus()
	{
		if ( this._isTransitioning || !$( this._parent ).hasClass( ClassName.ACTIVE ) ) {
			return;
		}

		const startEvent = $.Event( Event.HIDE );
		$( this._parent ).trigger( startEvent );
		if ( startEvent.isDefaultPrevented() ) {
			return;
		}

		this.setTransitioning( true );

		const complete = () => {
			this.setTransitioning( false );
			$( this._parent ).removeClass( ClassName.ACTIVE );
		};

		if ( ! Util.supportsTransitionEnd ) {
			complete();
			return;
		}

		$( this._parent )
			.one( Util.TRANSITION_END, complete )
			.emulateTransitionEnd( TRANSITION_DURATION );
	}

	toggle( e )
	{
		if ( window.innerWidth < 767 ) {
			return;
		}
		
		if ( e.type === 'mouseenter' ) {
			this.focus();
		} else if ( e.type === 'mouseleave' ) {
			this.unfocus();
		}
	}

	// static

	static getData()
	{
		var cards = document.getElementsByClassName( Selector.CARD );
		var size = cards.length;

		for ( var i = 0; i < size; i++ ) {
			console.log( $( cards[ i ] ).data( DATA_KEY ) );
		}
	}

	static _jQueryInterface( event, config )
	{
		return this.each( function () {
			let data = $( this ).data( DATA_KEY );

			if ( ! data ) {
				data = new PromvcCard( this );
				$( this ).data( DATA_KEY, data );
			}

			if ( config === 'toggle' ) {
				data[ config ]( event );
			}
		});
	}
}

/**
 * -----------------------------------------------------------------------------
 * Data API Implementation
 * -----------------------------------------------------------------------------
 */

$( document ).on( Event.MOUSE_ENTER_LEAVE_DATA_API, `.${Selector.CARD}`, function ( event ) {
	var $wrapper = $( this );
	PromvcCard._jQueryInterface.call( $wrapper, event, 'toggle' );
	event.stopPropagation();
});

/**
 * -----------------------------------------------------------------------------
 * jQuery Plugin Implementation
 * -----------------------------------------------------------------------------
 */

export default PromvcCard;